/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_New_Create_BookingInputs */

const en_admin_external_booking_new_create_booking = /** @type {(inputs: Admin_External_Booking_New_Create_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Booking`)
};

const de_admin_external_booking_new_create_booking = /** @type {(inputs: Admin_External_Booking_New_Create_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchen`)
};

const es_admin_external_booking_new_create_booking = /** @type {(inputs: Admin_External_Booking_New_Create_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear reserva`)
};

const fr_admin_external_booking_new_create_booking = /** @type {(inputs: Admin_External_Booking_New_Create_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer une réservation`)
};

const nl_admin_external_booking_new_create_booking = /** @type {(inputs: Admin_External_Booking_New_Create_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservering maken`)
};

/** @type {(inputs: Admin_External_Booking_New_Create_BookingInputs) => LocalizedString} */
const it_admin_external_booking_new_create_booking = en_admin_external_booking_new_create_booking;

/** @type {(inputs: Admin_External_Booking_New_Create_BookingInputs) => LocalizedString} */
const pt_br2_admin_external_booking_new_create_booking = en_admin_external_booking_new_create_booking;

/** @type {(inputs: Admin_External_Booking_New_Create_BookingInputs) => LocalizedString} */
const pl_admin_external_booking_new_create_booking = en_admin_external_booking_new_create_booking;

/** @type {(inputs: Admin_External_Booking_New_Create_BookingInputs) => LocalizedString} */
const hu_admin_external_booking_new_create_booking = en_admin_external_booking_new_create_booking;

/** @type {(inputs: Admin_External_Booking_New_Create_BookingInputs) => LocalizedString} */
const ro_admin_external_booking_new_create_booking = en_admin_external_booking_new_create_booking;

/**
* | output |
* | --- |
* | "Create Booking" |
*
* @param {Admin_External_Booking_New_Create_BookingInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_new_create_booking = /** @type {((inputs?: Admin_External_Booking_New_Create_BookingInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_New_Create_BookingInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_new_create_booking(inputs)
	if (locale === "de") return de_admin_external_booking_new_create_booking(inputs)
	if (locale === "es") return es_admin_external_booking_new_create_booking(inputs)
	if (locale === "fr") return fr_admin_external_booking_new_create_booking(inputs)
	if (locale === "nl") return nl_admin_external_booking_new_create_booking(inputs)
	if (locale === "it") return it_admin_external_booking_new_create_booking(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_new_create_booking(inputs)
	if (locale === "pl") return pl_admin_external_booking_new_create_booking(inputs)
	if (locale === "hu") return hu_admin_external_booking_new_create_booking(inputs)
	return ro_admin_external_booking_new_create_booking(inputs)
});
export { admin_external_booking_new_create_booking as "admin.external_booking_new.create_booking" }